import React, { FC } from 'react';

import { CellContext } from '@tanstack/react-table';

import { EntitlementsProject } from '@adsk/alloy-provider';
import { Box } from '@adsk/alloy-react-box';
import { OverflowTooltip } from '@adsk/alloy-react-tooltip';

export const NumberCell: FC<
  CellContext<EntitlementsProject, EntitlementsProject['jobNumber']>
> = ({ row, getValue }) => (
  <Box data-testid={`jobNumber:${row.original.jobNumber}`} width="100%">
    <OverflowTooltip triggerTarget={OverflowTooltip.TRIGGER_TARGETS.TOOLTIP}>
      {getValue()}
    </OverflowTooltip>
  </Box>
);
